import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import Layout from '../components/Layout';
import Login from '../components/Login';
import { isLoggedIn } from '../Services/UserService';

function LoginRoute() {
  return <Layout component={Login} />;
}

const loginSearchSchema = z.object({
  username: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  // Before loading the login page, check if user is already logged in
  beforeLoad: () => {
    // If user is already logged in, clear storage and reload
    // (This matches the behavior in the old router/index.tsx)
    if (isLoggedIn()) {
      const language = localStorage.getItem('language');
      localStorage.clear();
      if (language) {
        localStorage.setItem('language', language);
      }
    }
    return { documentTitle: { main: 'loginForm.login' } };
  },
  component: LoginRoute,
});
